import { api } from './../../api.js';

import axios from 'axios';

const state = {
	
}

const getters = {
	
}

const mutations = {

};

const actions = {


  getSessions: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/organizations/" + data.id+'/courses/'+data.course_id+'/sessions', data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getSession: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("admin/sessions/" + data.id,data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getSessionsPlayer: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .get("in-class-app/sessions/" + data.id + "/course",data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editSession: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .patch("admin/sessions/" + data.id, data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  createSession: function({ commit }, data) {
    return new Promise((resolve, reject) => {
      api
        .post("admin/sessions", data)
        .then(res => {
          resolve(res);
        })
        .catch(error => {
          reject(error.response);
        });
    });
  },
  completeSession: function({ commit }, data){
    return new Promise((resolve, reject) => {
      api.post("admin/sessions/"+ data.id+"/complete", data).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error.response);
      });
    });
  }

  
};

export default {
	state, 
	actions,
	getters,
	mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/SessionModule.js